export function initWeatherWidget() {
    const weatherWidget = document.getElementById('weather-widget');
    if (!weatherWidget) return;

    // Get the ADM4 code from the HTML data attribute
    const adm4_code = weatherWidget.dataset.adm4;
    if (!adm4_code) return;
    
    // Fetch data dari API Terbuka BMKG
    fetch(`https://api.bmkg.go.id/publik/prakiraan-cuaca?adm4=${adm4_code}`)
        .then(res => res.json())
        .then(res => {
            if (!res || !res.data || !res.data[0] || !res.data[0].cuaca) throw new Error("Invalid format");
            
            const data = res.data[0];
            const lokasi = data.lokasi;
            const cuacaDays = data.cuaca;
            const now = new Date();
            let currentCuaca = null;

            for (let i = 0; i < cuacaDays.length; i++) {
                for (let j = 0; j < cuacaDays[i].length; j++) {
                    const c = cuacaDays[i][j];
                    const cDate = new Date(c.local_datetime.replace(' ', 'T'));
                    if (cDate >= now || currentCuaca === null) {
                        currentCuaca = c;
                        break;
                    }
                }
                if (currentCuaca) break;
            }
            if (!currentCuaca) currentCuaca = cuacaDays[0][0];

            let iconClass = 'bi-cloud-sun';
            let textColor = 'text-warning';
            
            // Map cuaca BMKG (https://api.bmkg.go.id/)
            const weatherDesc = currentCuaca.weather_desc;
            const descLower = weatherDesc.toLowerCase();
            
            if (descLower.includes('hujan') || descLower.includes('gerimis')) {
                iconClass = 'bi-cloud-rain-heavy-fill';
                textColor = 'text-primary';
                if (descLower.includes('petir')) {
                    iconClass = 'bi-cloud-lightning-rain-fill';
                    textColor = 'text-danger';
                }
            } else if (descLower.includes('berawan')) {
                iconClass = 'bi-cloud-sun-fill';
                textColor = 'text-secondary';
                if (descLower.includes('tebal')) iconClass = 'bi-clouds-fill';
            } else if (descLower.includes('cerah')) {
                iconClass = 'bi-sun-fill';
                textColor = 'text-warning';
            }

            weatherWidget.innerHTML = `
                <i class="bi ${iconClass} ${textColor} me-2" style="font-size: 1.2rem;"></i>
                <div class="d-flex flex-column justify-content-center" style="line-height: 1.1;">
                    <div class="d-flex align-items-center gap-1">
                        <span class="fw-bold text-dark" style="font-size: 0.85rem;">${currentCuaca.t}°C</span>
                        <span class="text-primary" style="font-size: 0.65rem;"><i class="bi bi-geo-alt-fill"></i> ${lokasi.kotkab}</span>
                    </div>
                    <span class="text-muted" style="font-size: 0.65rem;">${weatherDesc}</span>
                </div>
            `;
            weatherWidget.title = `${lokasi.kotkab}, ${lokasi.kecamatan}: Suhu ${currentCuaca.t}°C, Kelembapan ${currentCuaca.hu}%, Angin ${currentCuaca.ws} km/h`;
            weatherWidget.classList.replace('bg-light', 'bg-white');
        })
        .catch(err => {
            console.error('BMKG Weather Error:', err);
            weatherWidget.innerHTML = `<i class="bi bi-cloud-slash text-muted me-2"></i><span class="text-muted small">Cuaca Gagal</span>`;
        });
}
